module.exports = __webpack_public_path__ + "media/ice_shopper_lifetime_metrics/eggs-61facd99.webp";